import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1.6rem;
`;

export const Sheet = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 1.6rem;
  padding: 2.4rem;
  width: 100%;
  max-width: 48rem;
  max-height: 90vh;
  overflow-y: auto;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`;

export const Title = styled.span`
  font-size: 1.8rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const CloseBtn = styled.button`
  background: none;
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.slateGrey};
  padding: 0.4rem;
  line-height: 1;
`;

export const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const OptionRow = styled.button<{ $accent: string }>`
  display: flex;
  align-items: center;
  gap: 1.4rem;
  width: 100%;
  padding: 1.6rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1.2rem;
  background-color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease;

  &:hover {
    border-color: ${({ $accent }) => $accent};
    background-color: ${({ $accent }) => `${$accent}0D`};
  }
`;

export const OptionEmoji = styled.div`
  font-size: 2.4rem;
  flex-shrink: 0;
  width: 4rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const OptionBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 0;
`;

export const OptionTitle = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const OptionSubtitle = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  line-height: 1.4;
`;

export const OptionChevron = styled.div<{ $accent: string }>`
  font-size: 1.6rem;
  font-weight: 700;
  color: ${({ $accent }) => $accent};
  flex-shrink: 0;
`;

export const FallbackRow = styled.div`
  margin-top: 1.8rem;
  padding-top: 1.6rem;
  border-top: 0.1rem solid ${({ theme }) => theme.colors.border};
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  text-align: center;
`;

export const FallbackLink = styled.button<{ $accent: string }>`
  background: none;
  border: none;
  padding: 0;
  font-family: inherit;
  font-size: 1.3rem;
  font-weight: 700;
  color: ${({ $accent }) => $accent};
  cursor: pointer;
`;
